import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    mapContainer: {
      height: '100%',
      width: '100%',
      '& > div': {
        backgroundColor: '#F4F4F4',
        border: 'solid 1px #D2D2D2',
        borderRadius: 5,
        height: '100%',
      },
    },
  }),
)
